const styles = (theme) => ({
  negativeTopMargin: {
    // Use negative margin to counter-act the displacement caused by the avatar
    [theme.breakpoints.up('md')]: {
      marginTop: '-30px',
    },
  },
  gridItem: {
    margin: `${theme.spacing.unit * 1.5}px 0`,
  },
  largeSection: {
    margin: `${theme.spacing.unit * 2}px 0`,
    [theme.breakpoints.up('sm')]: {
      margin: `${theme.spacing.unit * 3}px 0`,
    },
    [theme.breakpoints.up('md')]: {
      margin: `${theme.spacing.unit * 4}px 0`,
    },
  },
  largeSectionLast: {
    marginTop: theme.spacing.unit * 2,
    [theme.breakpoints.up('sm')]: {
      marginTop: theme.spacing.unit * 3,
    },
    [theme.breakpoints.up('md')]: {
      marginTop: theme.spacing.unit * 4,
    },
  },
  termsCheckbox: {
    alignSelf: 'flex-start',
    marginTop: '-10px',
  },
  gridItemRight: {
    textAlign: 'right',
  },
  avatar: {
    color: theme.palette.custom.accounts,
    marginTop: '0px',
    [theme.breakpoints.up('md')]: {
      marginTop: '10px',
    },
  },
  subCard: {
    padding: '24px',
    '&:last-child': {
      paddingBottom: theme.spacing.unit * 2,
    },
  },
  subCardHeadingDivider: {
    backgroundColor: theme.palette.border.dark,
  },
  bottomContent: {
    margin: `${theme.spacing.unit * 3}px 0`,
  },
  introText: {
    fontWeight: 600,
    fontSize: '1.1875rem',
    margin: `${theme.spacing.unit * 1.5}px 0 ${theme.spacing.unit * 3}px`,
    [theme.breakpoints.up('sm')]: {
      fontSize: '1.25rem',
    },
    [theme.breakpoints.up('md')]: {
      fontSize: '1.3125rem',
    },
  },
  subCardHeading: {
    fontWeight: 600,
    fontSize: '1.3125rem',
    margin: `0 0 ${theme.spacing.unit * 2}px`,
  },
  label: {
    fontWeight: 600,
    fontSize: '1.0625rem',
    marginBottom: '8px',
    marginTop: '8px',
    [theme.breakpoints.up('sm')]: {
      fontSize: '1.125rem',
    },
    [theme.breakpoints.up('md')]: {
      fontSize: '1.25rem',
    },
  },
  subLabel: {
    fontWeight: 400,
    fontSize: '1.0625rem',
    [theme.breakpoints.up('sm')]: {
      fontSize: '1.125rem',
    },
    [theme.breakpoints.up('md')]: {
      fontSize: '1.1875rem',
    },
  },
  arrangementTermsText: {
    marginTop: theme.spacing.unit * 3,
    textAlign: 'center',
  },
  createArrangementText: {
    textAlign: 'center',
    fontSize: '1.25rem',
    fontWeight: 600,
  },
  paymentLinkText: {
    display: 'inline-flex',
    whiteSpace: 'break-spaces',
    alignItems: 'center',
  },
  fieldsContainer: {
    marginBottom: theme.spacing.unit * 4,
  },
  fieldContainer: {
    marginTop: theme.spacing.unit * 1.5,
  },
  selectDisabled: {
    // Same opacity as used by other 'disabled' components in Material UI.
    opacity: 0.42,
  },
  checkboxLabel: {
    '&:first-of-type': {
      border: 'none',
    },
  },
  buttons: {
    marginTop: theme.spacing.unit * 4,
  },
  buttonsRight: {
    textAlign: 'right',
  },
  buttonNext: {
    marginLeft: theme.spacing.unit,
  },
  selectMenu: { marginTop: 6 },
  scheduleIcon: {
    color: theme.palette.primary.dark,
    marginRight: theme.spacing.unit,
    width: 22,
  },
});

export default styles;
